// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateCashAdvanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_cash_advance
 *
 * Validates input for creating an employee advance from a cash recebimento.
 */
import { registerContract } from './validate'

export interface Payroll_CreateCashAdvanceInput {
period_id: number
recebimento_id: number
franchise_id: number
}

registerContract('Payroll_CreateCashAdvanceInput', {
  period_id:      { type: 'number',  required: true },
  recebimento_id: { type: 'number',  required: true },
  franchise_id:   { type: 'number',  required: true },
})
